<template>
  <card>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :setImport="true"
      :exportFields="exportFields"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        "Полное имя": "full_name",
        "Номер телефона": {
          field: "phone",
          callback: (value) => {
            return "UZ " + value;
          },
        },
      },
      val: [],
      modalCreate: "guardian",
      fields: [
        {
          col: "col-12 col-md-6",
          key: "phone",
          label: "Номер телефона",
          type: "mask",
          mask: "+998#########",
          placeholder: "+998",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_guardian",
      itemLink: "business/guardians",
      setLink: "business/guardians",
      columns: [
        {
          key: "last_name",
          title: "Фамилия",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "first_name",
          title: "Имя",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },
        {
          detail: true,
          remove: false,
        },
      ],
    };
  },
};
</script>
<style>
</style>
